import React from "react";
import { Alert, Badge, Modal, Spinner } from "react-bootstrap";

function ModalValidasi({ show, handleClose, indikator, hasil, loading }) {
  const formula = hasil?.formula;

  return (
    <Modal show={show} onHide={handleClose} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "16px" }}>
          Validasi &mdash; {indikator?.code}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="d-flex align-items-center" style={{ fontSize: "12px" }}>
            <Spinner animation="border" size="sm" className="me-2" />
            Memeriksa konfigurasi...
          </div>
        )}

        {!loading && hasil && (
          <>
            <Alert variant={hasil.valid ? "success" : "danger"}>
              <div className="fw-bold">
                {hasil.valid
                  ? "Konfigurasi valid dan siap dipublish"
                  : "Konfigurasi belum valid"}
              </div>
              {!hasil.valid && (
                <ul className="mb-0 ps-3 mt-1" style={{ fontSize: "12px" }}>
                  {(hasil.masalah || []).map((val, i) => (
                    <li key={i}>{val}</li>
                  ))}
                </ul>
              )}
            </Alert>

            {formula && (
              <div className="mb-3" style={{ fontSize: "12px" }}>
                <div className="fw-bold mb-1">
                  Formula{" "}
                  <Badge bg={formula.valid ? "success" : "danger"}>
                    {formula.valid ? "valid" : "tidak valid"}
                  </Badge>
                </div>
                <code className="d-block p-2 bg-light rounded mb-2">
                  {indikator?.formula_expression}
                </code>
                {formula.error && (
                  <div className="text-danger mb-2">{formula.error}</div>
                )}
                <div className="text-muted" style={{ fontSize: "11px" }}>
                  Variabel yang dipakai: {(formula.variables || []).join(", ") || "-"}
                </div>
              </div>
            )}

            {hasil.variabel_tersedia && (
              <div style={{ fontSize: "11px" }}>
                <div className="fw-bold">Variabel tersedia</div>
                <div className="text-muted">
                  {hasil.variabel_tersedia.join(", ")}
                </div>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ModalValidasi;
